import { WrapperWidget } from '@agentselly/ui';
import { AppLink } from '~/components/AppLink';
import { T } from '@tolgee/react';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly link: string;
}

export function EvaluationContactWidget(props: Props) {
  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          <T>evaluation_contact_widget_title</T>
        </h2>

        <T>evaluation_contact_widget_text</T>

        <AppLink
          to={props.link}
          className="self-start"
        >
          <Button
            primary
            showArrow
          >
            <T>evaluation_contact_widget_button_text</T>
          </Button>
        </AppLink>
      </div>
    </WrapperWidget>
  );
}
